const translations = {
  "en": {
    "or": "or"
  },
  "zh-tw": {
    "or": "或"
  }
};

export default translations;
